import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  title: 'NUTRI MAPA TOTAL',
  desc: 'La guía nutricional de todos los ingredientes que usamos. Semáforo del plato, tablas de proteína, hierro y calcio. Para saber exactamente qué estás comiendo.',
  value: '$5.990'
}, {
  title: 'ADEREZOS DE AUTOR',
  desc: 'Fórmulas de aderezos infalibles para ensaladas, bowls y platos. Las 6 bases madres con variaciones. Todo con ingredientes de almacén argentino.',
  value: '$4.990'
}, {
  title: 'SALSAS QUE SALVAN TODO',
  desc: 'Salsas cremosas, rápidas y con umami. Bechamel de avena, pesto sin queso, salsa criolla, gravy vegetal y más.',
  value: '$4.990'
}, {
  title: 'LISTA MAESTRA DE COMPRAS',
  desc: 'Checklist imprimible de feria + almacén + freezer. Sustituciones, planner semanal y guía de conservación. Para nunca quedarte sin ingredientes.',
  value: '$2.990'
}, {
  title: 'PACK SALVAVIDAS',
  desc: 'Platos express de 15 minutos para días sin tiempo ni ganas. Para no caer en el delivery cuando no tenés ganas de cocinar.',
  value: '$3.990'
}, {
  title: 'GUÍA FAMILIA FELIZ',
  desc: 'Cómo lograr que les guste a todos. Swaps argentinos, trucos de textura y menú anti-quejas para convencer hasta al más carnívoro.',
  value: '$3.990'
}];
export function BonusSection() {
  return <section className="bg-[#18181b] py-6 px-4" data-id="element-16">
      <div className="max-w-5xl mx-auto" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-5" data-id="element-18">
          <div className="inline-block bg-emerald-900/50 border border-emerald-500/30 text-emerald-400 px-3 py-1 rounded-full text-xs font-bold mb-3" data-id="element-19">
            🎁 Gratis solo con tu compra hoy
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-20">
            Comprás Hoy y Recibís 6 Bonos Gratis
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-21">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-[#0a0a0a] border border-zinc-800 rounded-lg px-4 py-3 flex items-start gap-3" data-id="element-22">
              <span className="text-lg shrink-0 mt-0.5" data-id="element-23">🎁</span>
              <div className="flex-1 min-w-0" data-id="element-24">
                <div className="flex items-center justify-between gap-2 mb-0.5" data-id="element-25">
                  <h3 className="text-sm font-bold text-white leading-tight" data-id="element-26">
                    {bonus.title}
                  </h3>
                  <div className="text-xs shrink-0" data-id="element-27">
                    <span className="text-zinc-500 line-through mr-1" data-id="element-28">
                      {bonus.value}
                    </span>
                    <span className="text-emerald-400 font-bold" data-id="element-29">$0</span>
                  </div>
                </div>
                <p className="text-zinc-400 text-[11px] leading-snug" data-id="element-30">
                  {bonus.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}